import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import './Car.css';

const url = process.env.REACT_APP_BACKEND_URL;

const EditCar = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [districts, setDistricts] = useState([]);
  
  const [data, setData] = useState({
    tarkono: '',
    carname: '',
    ownername: '',
    ownerphone: '',
    drivername: '',
    driverphone: '',
    district: '',
  });

  // Fetch districts
  useEffect(() => {
    const fetchDistricts = async () => {
      try {
        const res = await axios.get(`${url}/api/district`);
        setDistricts(res.data.data || []);
      } catch (err) {
        toast.error('Failed to load districts');
      }
    };
    fetchDistricts();
  }, []);

  // Fetch car data
  useEffect(() => {
    const fetchCar = async () => {
      try {
        const response = await axios.get(`${url}/api/car/${id}`);
        const car = response.data.data;
        setData({
          tarkono: car.tarkono,
          carname: car.carname,
          ownername: car.ownername,
          ownerphone: car.ownerphone,
          drivername: car.drivername,
          driverphone: car.driverphone,
          district: car.district?._id || car.district || '',
        });
      } catch (error) {
        toast.error('Failed to load car data');
        navigate('/ViewCar');
      } finally {
        setLoading(false);
      }
    };
    fetchCar();
  }, [id, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate all fields
    for (const field in data) {
      if (!data[field]) {
        toast.error(`${field.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())} is required`);
        return;
      }
    }

    setSubmitting(true);

    try {
      const response = await axios.put(`${url}/api/car/${id}`, data);
      if (response.data.success) {
        toast.success('Car updated successfully!');
        navigate('/ViewCar');
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to update car');
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <div className="loading">Loading car...</div>;

  return (
    <div className="district-container">
      <div className="header">
        <h2>Edit Car</h2>
        <button onClick={() => navigate('/ViewCar')} className="add-button">
          Back to List
        </button>
      </div>

      <form className="district-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Tarkono</label>
          <input
            type="text"
            name="tarkono"
            value={data.tarkono}
            onChange={handleChange}
            placeholder="Enter tarkono"
            required
          />
        </div>

        <div className="form-group">
          <label>Car Name</label>
          <input
            type="text"
            name="carname"
            value={data.carname}
            onChange={handleChange}
            placeholder="Enter car name"
            required
          />
        </div>

        <div className="form-group">
          <label>Owner Name</label>
          <input
            type="text"
            name="ownername"
            value={data.ownername}
            onChange={handleChange}
            placeholder="Enter owner name"
            required
          />
        </div>

        <div className="form-group">
          <label>Owner Phone</label>
          <input
            type="text"
            name="ownerphone"
            value={data.ownerphone}
            onChange={handleChange}
            placeholder="Enter owner phone"
            required
          />
        </div>

        <div className="form-group">
          <label>Driver Name</label>
          <input
            type="text"
            name="drivername"
            value={data.drivername}
            onChange={handleChange}
            placeholder="Enter driver name"
            required
          />
        </div>

        <div className="form-group">
          <label>Driver Phone</label>
          <input
            type="text"
            name="driverphone"
            value={data.driverphone}
            onChange={handleChange}
            placeholder="Enter driver phone"
            required
          />
        </div>

        <div className="form-group">
          <label>District</label>
          <select
            name="district"
            value={data.district}
            onChange={handleChange}
            required
          >
            <option value="">Select District</option>
            {districts.map((d) => (
              <option key={d._id} value={d._id}>
                {d.name}
              </option>
            ))}
          </select>
        </div>

        <div className="form-actions">
          <button type="submit" className="submit-button" disabled={submitting}>
            {submitting ? "Updating..." : "Update Car"}
          </button>
          <button
            type="button"
            onClick={() => navigate('/ViewCar')}
            className="cancel-button"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditCar;